import {NextPagePaginatedEvent, PagePaginatedEvent, PreviousPagePaginatedEvent} from "./events";
import {EventBus} from "../../../../common/ts/events/EventBus";
import {WhitelabelEvent} from "../../../../common/ts/events/Events";
import tracking from "../../../../common/ts/core/tracking";

let eventBus: EventBus;

const PAGINATION_PAGE_TRACKING_PREFIX_EVENT_NAME = 'serp-pagination-page-'
const PAGINATION_NEXT_TRACKING_EVENT_NAME = 'serp-pagination-next'
const PAGINATION_PREVIOUS_TRACKING_EVENT_NAME = 'serp-pagination-previous'

export function nextPagePaginatedEventEventHandler(event: WhitelabelEvent) {
    eventBus.emit(new tracking.TrackAnalyticsEvent({name: PAGINATION_NEXT_TRACKING_EVENT_NAME}))
}
export function previousPagePaginatedEventEventHandler(event: WhitelabelEvent) {
    eventBus.emit(new tracking.TrackAnalyticsEvent({name: PAGINATION_PREVIOUS_TRACKING_EVENT_NAME}))
}
export function pagePaginatedEventPayloadEventHandler(event: WhitelabelEvent) {
    const {payload: {pageNumber}} = event as PagePaginatedEvent;
    eventBus.emit(new tracking.TrackAnalyticsEvent({name: `${PAGINATION_PAGE_TRACKING_PREFIX_EVENT_NAME}${pageNumber}`}))
}

function init(ev: any = EventBus.getInstance()) {
    eventBus = ev;
    eventBus.subscribe(PreviousPagePaginatedEvent.TYPE, previousPagePaginatedEventEventHandler);
    eventBus.subscribe(NextPagePaginatedEvent.TYPE, nextPagePaginatedEventEventHandler);
    eventBus.subscribe(PagePaginatedEvent.TYPE, pagePaginatedEventPayloadEventHandler);
}

export default {
    init
};
